import { Component, OnInit, viewChild, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule, NgClass, AsyncPipe } from '@angular/common';
import { findNewSchoolsService } from 'src/app/services/api/consumer/find-new-schools.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DirectivesModule } from 'src/app/directives.module';
import { co, el } from '@fullcalendar/core/internal-common';
import { PaginationComponent } from 'ngx-bootstrap/pagination';
import { PageChangedEvent } from 'ngx-bootstrap/pagination/public_api';
import { ActivatedRoute, Router } from '@angular/router';
import { CompleteProfileChartComponent } from '../complete-profile-chart/complete-profile-chart.component';
import { environment } from 'src/environments/environment';
import { SchoolData } from 'src/app/models/schoolUser';
import { mySchoolsService } from 'src/app/services/api/consumer/myschools.service';

import { ArticleComponent } from '../../producer/article/article.component';

@Component({
  selector: 'app-find-new-schools',
  standalone: true,
  imports: [
    DirectivesModule,
    CommonModule,
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    AsyncPipe,
    PaginationComponent,
    CompleteProfileChartComponent,
    ArticleComponent
  ],
  templateUrl: './find-new-schools.component.html',
  styleUrl: './find-new-schools.component.scss',
})
export class FindNewSchoolsComponent {
  @ViewChild('actionModals') actionModals: any;
  @ViewChild('acceptRequestModal') acceptRequestModal: any;
  @ViewChild('cancelRequestModal') cancelRequestModal: any;
  @ViewChild('setPreferenceModalTemplate') setPreferenceModalTemplate: any;

  // Data sources for async pipe
  private invitesSubject = new BehaviorSubject<any[]>([]);
  private historySubject = new BehaviorSubject<any[]>([]);
  invitesSchoolsList = this.invitesSubject.asObservable();
  invitesHistorySchoolsList = this.historySubject.asObservable();
  public teacherData!: SchoolData;
  schoolData: any;


  // Forms
  declineInviteForm: FormGroup;
  schoolInvitesFilterForm: FormGroup;
  schoolInvitesHistoryFilterForm: FormGroup;
  schoolInvitesPendingFilterForm: FormGroup;
  actionForm: FormGroup;

  currentPage: number = 1;
  totalCount: number = 0;
  // Modal state
  actionType: 'accept' | 'decline' | null = null;
  schoolName: string = '';
  school: any = null;

  invitesData: any[] = [];
  historyData: any[] = [];
  pendingData: any[] = [];
  schoolDetails: any[] = [];
  selectAllCheck = false;
  hideButton = true;
  activeTab: 'invites' | 'pending' | 'history' = 'invites';
  currentHistoryPage = 1;
  schoolLengthLimit = 0;
  schoolHistoryLengthLimit = 0;
  schoolPendingLengthLimit = 0;
  submitted = false;
  teacherProfile: any;

  private pendingSubject = new BehaviorSubject<any[]>([]);
  pendingSchoolsList = this.pendingSubject.asObservable();
  school_level: any;
  school_type: any;
  distance_choice: any;
  region_choice: any;
  groupChoice: any;
  groupName: string = '';
  subGroupName: string = '';

  preferenceForm!: FormGroup;
  yearLevels = [
    { label: 'Prep/Foundation', value: '0' },
    { label: 'Year 1', value: '1' },
    { label: 'Year 2', value: '2' },
    { label: 'Year 3', value: '3' },
    { label: 'Year 4', value: '4' },
    { label: 'Year 5', value: '5' },
    { label: 'Year 6', value: '6' },
    { label: 'Year 7', value: '7' },
    { label: 'Year 8', value: '8' },
    { label: 'Year 9', value: '9' },
    { label: 'Year 10', value: '10' },
    { label: 'Year 11', value: '11' },
    { label: 'Year 12', value: '12' },
    { label: 'SEP', value: 'SEP' },
    { label: 'SSEP', value: 'SSEP' },
    { label: 'ECDP', value: 'ECDP' },

  ];

  constructor(
    private findNewSchoolsService: findNewSchoolsService,
    private ngxService: NgxUiLoaderService,
    private fb: FormBuilder,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private toastr: ToastrService,
    private router: Router,
    private mySchoolsService: mySchoolsService
  ) {
    this.declineInviteForm = this.fb.group({});
    this.schoolInvitesFilterForm = this.fb.group({
      title: [''],
      pincode: [''],
      distance: ['10000000'],
      school_level: [''],
      school_type: [''],
      page: [''],
      new_school: [0],
      region: [''],
      sector: [''],
      group: [''],
    });
    this.schoolInvitesHistoryFilterForm = this.fb.group({
      title: [''],
    });
    this.schoolInvitesPendingFilterForm = this.fb.group({
      title: [''],
    });
    this.actionForm = this.fb.group({
      school_id: [''],
      sub_group_request: [false],
    });
  }

  ngOnInit(): void {
    this.loadOnFilter();
    this.loadChoices();
    this.teacherData = JSON.parse(localStorage.getItem('userData') || '{}');

    this.preferenceForm = this.fb.group({
      preferred_year_level: [[], Validators.required],
      work_type: [[], Validators.required],
      myteacher_id: [],
    });
  }


  setPreferenceModal(data: any, school: any) {
    this.prefillForm(data);
    // console.log('Prefilled form data:', data);
    // console.log('School data:', school);
    this.schoolData = school;
    // console.log('Prefilled form data:', this.preferenceForm.value);
    setTimeout(() => {
      this.bsModalRef = this.modalService.show(this.setPreferenceModalTemplate, {
        class: 'modal-md',
        backdrop: 'static',
      });
    }, 500);
  }

  saveSchoolPreferences() {
    if (this.preferenceForm.invalid) {
      this.preferenceForm.markAllAsTouched();
      return;
    }
    this.ngxService.start();
    const payload = this.preferenceForm.value;
    // return;
    // Output: { preferred_year_level: ["0", "1", "2"], work_type: ["C", "T"] }


    // Here you can send the selectedPreferences to your backend API
    // For example:
    this.mySchoolsService.setPreferencesAPI(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.ngxService.stop();
          this.toastr.success(res.message || 'Preferences saved successfully');
          this.bsModalRef.hide();
          this.schoolInvitesFilterForm.reset({
            title: '',
            pincode: '',
            distance: '10000000',
            school_level: '',
            school_type: '',
            page: '',
            new_school: 0,
            region: '',
            sector: '',
          });
          this.loadInvites();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        this.toastr.error(err.error.message);
        console.log(err);
      },
    });
  }

  onYearLevelChange(event: any) {
    const selected = [...this.preferenceForm.value.preferred_year_level];
    if (event.target.checked) {
      selected.push(event.target.value);
    } else {
      const index = selected.indexOf(event.target.value);
      if (index > -1) selected.splice(index, 1);
    }
    this.preferenceForm.patchValue({ preferred_year_level: selected });
    this.preferenceForm.get('preferred_year_level')?.updateValueAndValidity();
  }

  onWorkTypeChange(event: any) {
    const selected = [...this.preferenceForm.value.work_type];
    if (event.target.checked) {
      selected.push(event.target.value);
    } else {
      const index = selected.indexOf(event.target.value);
      if (index > -1) selected.splice(index, 1);
    }
    this.preferenceForm.patchValue({ work_type: selected });
    this.preferenceForm.get('work_type')?.updateValueAndValidity();
  }

  prefillForm(data: any) {
    if (!data) return;

    const preferred = data.preferred_year_level || [];
    const workType = data.work_type || [];

    this.preferenceForm.patchValue({
      preferred_year_level: preferred,
      work_type: workType,
      myteacher_id: data.myteacher_id,
    });
  }

  loadChoices(): void {
    // Load choices data
    this.ngxService.start();
    const params = {
      source: 'fns',
    };
    this.findNewSchoolsService.teacherChoicesAPI(params).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.school_level = res.choices?.school_level || [];
          this.school_type = res.choices?.school_type || [];
          this.distance_choice = res.choices?.distance_choice || [];
          this.region_choice = res.choices?.school_region || [];
          this.groupChoice = res.choices?.group || [];

          this.ngxService.stop();
        } else {
          this.toastr.error(res.message || 'Failed to load choices');
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.toastr.error(err.message || 'Failed to load choices');
        this.ngxService.stop();
      },
    });
  }
  pageDetails: any;
  loadOnFilter(): void {
    // Load invites data
    this.ngxService.start();
    // Set new_school to '0' (or update this logic as needed)
    const formValue = this.schoolInvitesFilterForm.value;
    this.schoolInvitesFilterForm.patchValue({ page: this.currentPage });
    formValue.new_school = formValue.new_school ? '1' : '0';
    this.findNewSchoolsService
      .findnewSchoolsAPI(formValue)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            this.pageDetails = res.data;
            this.invitesData = res.data.school_list || [];
            this.invitesSubject.next(this.invitesData);
            this.schoolLengthLimit = res.data?.total_count || 0;
            this.totalCount = parseInt(res.data.page_count) * 10;
            this.teacherProfile = res.data.teacher_profile;
            this.ngxService.stop();
          } else {
            this.toastr.error(res.message || 'Failed to load invites');
            this.ngxService.stop();
          }
        },
        error: (err: any) => {
          this.toastr.error(err.message || 'Failed to load invites');
          this.ngxService.stop();
        },
      });
  }

  loadInvites(): void {
    // Load invites data 
    this.ngxService.start();
    const formValue = this.schoolInvitesFilterForm.value;
    formValue.new_school = formValue.new_school ? '1' : '0';
    this.findNewSchoolsService
      .findnewSchoolsAPI(formValue)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            this.pageDetails = res.data;
            this.invitesData = res.data.school_list || [];
            this.invitesSubject.next(this.invitesData);
            this.schoolLengthLimit = res.data?.total_count || 0;
            this.totalCount = parseInt(res.data.page_count) * 10;
            this.selectAllCheck = false;
            this.schoolDetails = [];
            this.hideButton = true;
            this.ngxService.stop();
          } else {
            this.toastr.error(res.message || 'Failed to load invites');
            this.ngxService.stop();
          }
        },
        error: (err: any) => {
          this.toastr.error(err.message || 'Failed to load invites');
          this.ngxService.stop();
        },
      });
  }
  // Unified tab switch handler
  onTabChange(tab: 'invites' | 'pending' | 'history') {
    this.activeTab = tab;
    if (tab === 'invites') {
      this.currentPage = 1;
      this.loadInvites();
    } else if (tab === 'history') {
      this.loadHistory();
    } else if (tab === 'pending') {
      this.loadPending();
    } else {
      this.currentPage = 1;
      this.loadInvites();
    }
  }

  // Modal openers
  OpenAccepetRequestModal(
    id: any = null,
    sub_group_accept: boolean,
    title: string,
    group_name: string,
    sub_group_name: string,
    get_all_data: any,
    get_group_data: any
  ): void {
    this.singleSelectedSchoolId = id ? id.toString() : null;
    this.subGroupAccept = sub_group_accept;
    this.schoolName = title;
    this.groupName = group_name;
    this.subGroupName = sub_group_name;
    if (!this.pageDetails.bce_isValidated && get_group_data.group_name == 'Diocese of Brisbane') {
      if (this.pageDetails.bce_status) {
        this.toastr.warning('Your profile is being reviewed by the Brisbane Catholic Education head office. Once validated, you will be able to request to be a part of this school\'s list.');
      } else {
        this.toastr.warning('Please complete the Brisbane Catholic Education questionnaire in your profile to be able to work with BCE Schools.');
      }
      return;
    }
    this.bsModalRef = this.modalService.show(this.acceptRequestModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }

  // Load history data
  loadHistory() {
    this.schoolInvitesFilterForm.reset({
      title: '',
      pincode: '',
      distance: '10000000',
      school_level: '',
      school_type: '',
      page: '',
      new_school: 0,
      region: '',
      sector: '',
    });
    this.schoolInvitesPendingFilterForm.reset({
      title: '',
    });

    this.ngxService.start();
    this.findNewSchoolsService
      .pendingHistoryAPI(this.schoolInvitesHistoryFilterForm.value)
      .subscribe({
        next: (res: any) => {
          this.historyData = res.data || [];
          console.log(this.historyData);
          this.historySubject.next(this.historyData);
          this.schoolHistoryLengthLimit = res.data?.total_count || 0;
          this.ngxService.stop();
        },
        error: (err: any) => {
          this.toastr.error(err.message || 'Failed to load history');
          this.ngxService.stop();
        },
      });
  }
  // Load pending data
  loadPending() {
    this.schoolInvitesFilterForm.reset({
      title: '',
      pincode: '',
      distance: '10000000',
      school_level: '',
      school_type: '',
      page: '',
      new_school: 0,
      region: '',
      sector: '',
    });
    this.ngxService.start();
    this.schoolInvitesHistoryFilterForm.reset({
      title: '',
    });
    this.findNewSchoolsService
      .pendingInvitesAPI(this.schoolInvitesPendingFilterForm.value)
      .subscribe({
        next: (res: any) => {
          this.pendingData = res.data || [];
          console.log(this.pendingData);
          this.pendingSubject.next(this.pendingData);
          this.schoolPendingLengthLimit = res.data?.total_count || 0;
          this.ngxService.stop();
        },
        error: (err: any) => {
          this.toastr.error(err.message || 'Failed to load history');
          this.ngxService.stop();
        },
      });
  }

  // Search/filter handler
  getFilterInputs() {
    if (this.activeTab === 'pending') {
      this.currentPage = 1;
      this.loadPending();
    } else {
      this.currentHistoryPage = 1;
      this.loadHistory();
    }
  }
  // Select all/individual checkboxes
  selectAll(type: any, event: any) {
    const checked = event.target.checked;
    if (type === 'All') {
      this.schoolDetails = [];
      this.invitesData.forEach((x: any) => {
        x.isChecked = checked;
        if (checked) {
          this.schoolDetails.push(x);
        }
      });
      this.hideButton = !checked;
    } else {
      type.isChecked = checked;
      if (checked) {
        this.schoolDetails.push(type);
      } else {
        this.schoolDetails = this.schoolDetails.filter((x) => x !== type);
      }
      this.hideButton = this.schoolDetails.length === 0;
    }
    this.selectAllCheck =
      this.invitesData.length === this.schoolDetails.length &&
      this.invitesData.length > 0;
  }

  // Add a property to store the single selected school id
  singleSelectedSchoolId: string | null = null;
  subGroupAccept: boolean = false;

  // Actions handler
  async actions(school: any, action: 'accept' | 'decline') {
    this.actionType = action;
    this.submitted = true;
    this.ngxService.start();

    let requestIds: string;

    // If bulk action, use selected schools; if single, use stored id
    if (
      (action === 'accept' || action === 'decline') &&
      this.schoolDetails.length > 0
    ) {
      requestIds = this.schoolDetails.map((item) => item.id).join(',');
    } else if (this.singleSelectedSchoolId) {
      requestIds = this.singleSelectedSchoolId;
    } else {
      requestIds = school.id.toString();
    }

    this.actionForm.patchValue({
      provider_ids: requestIds,
    });

    await this.sendInviteCall(this.actionForm.value);
  }

  async sendInviteCall(requestData: any, school?: any) {
    this.findNewSchoolsService.sendInviteAPI(requestData).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.bsModalRef.hide();
          this.toastr.success(res.message);
          this.schoolDetails = [];
          this.hideButton = true;
          // this.loadInvites();
          // console.log('Response Data:', school?.is_set_preferrence);
          if (school?.is_set_preferrence) {
            this.setPreferenceModal(res.data, school);
          } else {
            setTimeout(() => {
              this.loadInvites();
            }, 500);
          }
        } else {
          this.toastr.error(res.message);
        }
        this.ngxService.stop();
      },
      error: (err: any) => {
        this.toastr.error(err.statusText + ', Please contact admin');
        this.ngxService.stop();
      },
    });
  }

  // Actions handler for "Send Request" only
  sendRequest(school: any, subGroupAccept: boolean) {
    this.submitted = true;
    this.ngxService.start();

    let requestIds: string;

    // Use bulk selection if available, otherwise use single selected id, otherwise fallback to the passed school
    if (this.schoolDetails.length > 0) {
      requestIds = this.schoolDetails.map((item) => item.id).join(',');
    } else if (this.singleSelectedSchoolId) {
      requestIds = this.singleSelectedSchoolId;
    } else {
      requestIds = school.toString();
    }

    this.actionForm.patchValue({
      school_id: requestIds,
      sub_group_request: subGroupAccept,
    });

    this.findNewSchoolsService.sendInviteAPI(this.actionForm.value).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.bsModalRef.hide();
          this.toastr.success(res.message);
          this.schoolDetails = [];
          this.hideButton = true;
          this.loadInvites();
        } else {
          this.toastr.error(res.message);
        }
        this.ngxService.stop();
      },
      error: (err: any) => {
        this.toastr.error(err.statusText + ', Please contact admin');
        this.ngxService.stop();
      },
    });
  }

  async addtoSchool(school: any) {
    this.ngxService.start();
    const requestData = {
      school_id: school?.id,
      from_qld_teacher: true,
    };
    await this.sendInviteCall(requestData, school);
    this.ngxService.stop();
  }

  openCancelRequestModal(id: any) {
    this.singleSelectedSchoolId = id ? id.toString() : null;
    this.bsModalRef = this.modalService.show(this.cancelRequestModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }
  cancelInvite(school: any) {
    this.submitted = true;
    this.ngxService.start();

    const requestData = {
      invite_id: school,
    };

    this.findNewSchoolsService.cancelInviteAPI(requestData).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.bsModalRef.hide();
          this.toastr.success(res.message);
          this.loadPending();
        } else {
          this.toastr.error(res.message);
        }
        this.ngxService.stop();
      },
      error: (err: any) => {
        this.toastr.error(err.statusText + ', Please contact admin');
        this.ngxService.stop();
      },
    });
  }

  pageChanged(event: PageChangedEvent): void {
    this.ngxService.start();
    window.scrollTo(0, 0);
    this.schoolInvitesFilterForm.patchValue({ page: event.page });
    this.loadOnFilter();
  }
  goToSettingsPage() {
    this.router.navigate(['teacher/settings']);
  }
  viewAsTeacher(slug: any) {
    console.log('called');
    // this._router.navigate(["school/school-profile/"+this.profileData?.slug]);
    window.open(environment.siteUrl + 'public-profile/' + slug);
  }
  handlePageData(data: any) {
    // Store the page data for later use, e.g. pagination or display
    this.pageData = data;
    // Optionally, update the UI or trigger other logic if needed
    // Example: this.obsArray.next(data.consumer_list || []);
  }
  pageData: any;
}
